/* eslint-disable @typescript-eslint/no-empty-interface */
import { CallbackModal, CallbackForm } from '@cian/callback-widget';
import * as React from 'react';

import { IWorkTimeInfoSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import * as Analytics from './tracking';

import { requestCallback } from '../../../api/callback';
import { IPopupCallbackProps } from './container';

export interface IPopupCallbackState {}

export class PopupCallback extends React.Component<IPopupCallbackProps, IPopupCallbackState> {
  public render() {
    const {
      offer,
      phones,
      callbackContent: { modalTitle, modalDescription, successTitle, modalButtonText },
    } = this.props;

    // tslint:disable-next-line
    const callbackSettings = offer.workTimeInfo || ({} as IWorkTimeInfoSchema);

    const phone = phones && phones.length > 0 ? `${phones[0].countryCode}${phones[0].number}` : '';

    return this.props.isOpen ? (
      <CallbackModal root={document.body}>
        <CallbackForm
          agentPhone={phone}
          requestCallback={requestCallback.bind(this, this.props.makeRequest, this.props.host)}
          onSuccess={this.onSuccess}
          close={this.onPopupClose}
          sendAnalytics={false}
          isTimezoneMode={!this.props.useOldWidget}
          isNightMode={!callbackSettings.isAvailable}
          content={{
            title: modalTitle,
            description: modalDescription,
            buttonText: modalButtonText,
            successTitle,
          }}
          {...callbackSettings}
        />
      </CallbackModal>
    ) : null;
  }

  private onPopupClose = () => {
    this.props.toggle(!this.props.isOpen);
  };

  private onSuccess = () => {
    Analytics.trackResponseSuccess(this.props.opener, this.props.offer, this.props.agent);
  };
}
